<div class="row">
  <div class="col-md-6">
    <a routerLink="/" class="btn btn-link">
      <i class="fa fa-arrow-circle-o-left"></i> Back to Dashboard
    </a>
  </div>
  <div class="col-md-6">

  </div>
</div>

<div class="card">
  <div class="card-header">
    Edit Settings
  </div>
  <div class="card-body">
    <form (submit)="onSubmit()">

      <div class="form-group">
        <label>Allow Registration</label>
        <input
          type="checkbox"
          name="allowRegistration"
          [checked]="settings.allowRegistration"
          (change)="settings.allowRegistration = !settings.allowRegistration">
      </div>

      <div class="form-group">
        <label>Disable Balance on Add</label>
        <input
          type="checkbox"
          name="disableBalanceOnAdd"
          [checked]="settings.disableBalanceOnAdd"
          (change)="settings.disableBalanceOnAdd = !settings.disableBalanceOnAdd">
      </div>

      <div class="form-group">
        <label>Disable Balance on Edit</label>
        <input
          type="checkbox"
          name="disableBalanceOnEdit"
          [checked]="settings.disableBalanceOnEdit"
          (change)="settings.disableBalanceOnEdit = !settings.disableBalanceOnEdit">
      </div>

      <input type="submit" value="Submit" class="btn btn-primary btn-block">
    </form>
  </div>
</div>
